import React, { useMemo } from "react";
import ReraitManager from "./ReraitManager";

export default function ProjectReraitSettings({ project }) {
  const projectList = useMemo(
    () => [
      {
        id: project.id,
        user_id: project.user_id,
        project_name: project.project_name,
        used_pages: project.used_pages || "",
      },
    ],
    [project.id, project.user_id, project.project_name, project.used_pages]
  );

  return (
    <ReraitManager
      projects={projectList}
      fixedProjectId={project.id}
      targetUserId={project.user_id}
      title={`Авто переопубликация проекта ${project.project_name}`}
    />
  );
}
